/* Mobile burger menu reposition */

export function mobile_menu_reposition() {

	( ( $ ) => {

		const site_navigation_original_position = $( "#site-navigation" ).offset().top + $( "#site-navigation" ).outerHeight();

		// Initial top position
		$( '#mobile-navigation' ).css( 'top', site_navigation_original_position );

		const cov_mobile_menu_reposition = ( ev ) => {

			const site_topbar_position = ( $( "#site-navigation" ).offset().top + $( "#site-navigation" ).outerHeight() ) - $( window ).scrollTop();

			$( '#mobile-navigation' ).css( 'top', site_topbar_position );
		}

		$( window ).on( 'resize', cov_mobile_menu_reposition );
		$( window ).on( 'scroll', cov_mobile_menu_reposition );
		$( '.announcement-bar--top-bar .alert' ).on( 'closed.bs.alert', cov_mobile_menu_reposition );

	} )( window.jQuery );

}
